import { EmptyContent } from "../../../components/EmptyContent";
import { ScreenLayout } from "../../../components/ScreenLayout";
import { Spinner } from "../../../mobile/components/common";
import { TicketList } from "../../../components/Ticket/TicketList";
import { useActiveTickets } from "state/tickets/hooks";
import { ErrorMessage } from "views/components/Message";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "reactn";
import { useAuth } from "hooks/useAuth";
import { TemporaryUserInfo } from "views/components/TemporaryUserInfo";
import { useLocalStorageTickets } from "hooks/useSetLocalStorageTickets";

const TicketsScreen = () => {
	const [loading, error, tickets] = useActiveTickets();
	const { isLoggedInTemporary } = useAuth();

	return (
		<ScreenLayout
			title="Mis Tickets"
			description="Revisa los tickets que has sacado, aquí:"
			contentAligned={true}
		>
			{isLoggedInTemporary && !tickets.length ? (
				<TemporaryUserInfo
					isLoggedInTemporary={isLoggedInTemporary}
					desktop
				/>
			) : (
				<>
					{error && <ErrorMessage error={error} />}
					{loading && <Spinner full></Spinner>}
					{!loading && !tickets.length && (
						<EmptyContent description="No has sacado tickets aún..." />
					)}
					{!loading && !!tickets.length && (
						<TicketList tickets={tickets} />
					)}
					{!isLoggedInTemporary && (
						<Link to="/ticket-history">
							Ver registro histórico de tickets
						</Link>
					)}
				</>
			)}
			{/*  */}
		</ScreenLayout>
	);
};

export default TicketsScreen;
